import { normalize } from './engine';

/** Literal word-prefix search over prose; no quadratic fuzzy matching of whole documents. */
export function contentSnippet(query: string, content: string): string | null {
  const terms = normalize(query).split(' ').filter(Boolean);
  if (terms.length === 0) return null;
  const text = content.replace(/!\[[^\]]*\]\([^)]*\)/g, '').replace(/\[([^\]]+)\]\([^)]*\)/g, '$1').replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
  const words = [...text.matchAll(/[\p{L}\p{N}]+/gu)].map(word => ({ normalized: normalize(word[0]), index: word.index }));
  const hits = terms.map(term => words.find(word => word.normalized.startsWith(term)));
  if (hits.some(hit => !hit)) return null;
  const at = hits[0]!.index;
  const start = Math.max(0, at - 65);
  const end = Math.min(text.length, Math.max(at + 110, start + 180));
  return `${start > 0 ? '…' : ''}${text.slice(start, end)}${end < text.length ? '…' : ''}`;
}
